cockpitApp.controller('sidenavAutomaticCheckinController', [
  '$rootScope', '$scope', '$mdSidenav', '$filter', '$localStorage', 'automaticCheckin', 'logsProvider', '$mdMedia', 'countries', 'markups', 'gettextCatalog', 'basketHelper', 'profileHelper', 'segmentHelper',
  function($rootScope, $scope, $mdSidenav, $filter, $localStorage, automaticCheckin, logsProvider, $mdMedia, countries, markups, gettextCatalog, basketHelper, profileHelper, segmentHelper)
  {
    $scope.keyFeatures = {
      benefits: [
        gettextCatalog.getString('Receive your boarding passes right in time by email before departure'),
        gettextCatalog.getString('Save time and avoid long queues at the airport'),
        gettextCatalog.getString('Convenient, practical and uncomplicated')
      ]
    };

    $scope.marketingFlag = true;

    $scope.resetCheckinSidenav = function() {
      $scope.segment = null;
      $scope.status = '';
      $scope.selectedPassengerPnrPosition = null;
      $scope.isSeatPreferenceOpen = false;
      $scope.isPassengerDetailsOpen = false;
      $scope.passengersFrequentFlyerNumber = [];
      $scope.checkinPassengerList = [];
      $scope.checkinData = {};
      $scope.futureFlightSegments = segmentHelper.getFutureFlightSegments();
      $scope.setSegmentSeats();
      $scope.requirements = {};
      $scope.dates = {};
      $scope.email = {
        value: ''
      };

      $scope.genders = [{
        name: gettextCatalog.getString('Male'),
        value: 'M'
      }, {
        name: gettextCatalog.getString('Female'),
        value: 'F'
      }];

      $scope.seatPositions = [{
        label: gettextCatalog.getString('Window'),
        value: 'window'
      }, {
        label: gettextCatalog.getString('Middle'),
        value: 'middle'
      }, {
        label: gettextCatalog.getString('Aisle'),
        value: 'aisle'
      }];

      $scope.planeSections = [{
        label: gettextCatalog.getString('Front'),
        value: 'front'
      }, {
        label: gettextCatalog.getString('Middle'),
        value: 'middle'
      }, {
        label: gettextCatalog.getString('Rear'),
        value: 'back'
      }];

      $scope.resetSeatPreferences();
      $scope.first = true;
    };

    $scope.setSegmentSeats = function() {
      $scope.segmentsWithSeats = [];
      $scope.segmentWithoutSeats = [];

      $scope.futureFlightSegments && $scope.futureFlightSegments.map(function(futureFlightSegment) {
        var segmentHasSeats = futureFlightSegment.passengers.some(function(passenger) {
          return passenger.seatRequest;
        });

        if (segmentHasSeats) {
          $scope.segmentsWithSeats.push(futureFlightSegment);
        } else {
          $scope.segmentWithoutSeats.push(futureFlightSegment);
        }
      });
    };

    $scope.resetSeatPreferences = function() {
      var seatPreferences = null;
      $scope.displaySeatSelection = false;

      if ($localStorage.cockpit.baskets[$rootScope.activeFilekey] && $localStorage.cockpit.baskets[$rootScope.activeFilekey].automaticCheckins && $localStorage.cockpit.baskets[$rootScope.activeFilekey].automaticCheckins.preferences) {
        seatPreferences = $localStorage.cockpit.baskets[$rootScope.activeFilekey].automaticCheckins.preferences;
        $scope.displaySeatSelection = true;
      }

      $scope.seatPreferences = {
        seating: seatPreferences ? angular.copy(seatPreferences.seating) : null,
        locationInPlane: seatPreferences ? angular.copy(seatPreferences.locationInPlane) : null
      };
    };

    $scope.$watch(function() {
      return $mdSidenav('sidenavAutomaticCheckin').isOpen();
    }, function(newValue) {
      $rootScope.isSideNavOpen = newValue;

      if (!$rootScope.isSideNavOpen) {
        $scope.resetCheckinSidenav();
      }
    });

    $scope.closeAciUpsellMarketing = function () {
      $scope.marketingFlag = false;
      $localStorage.cockpit.marketing = { aci : false };
    };

    $scope.loadLocalStorageMarketingFlag = function () {
      if ($localStorage.cockpit.marketing && 'aci' in $localStorage.cockpit.marketing) {
        $scope.marketingFlag =  $localStorage.cockpit.marketing.aci;
      } else {
        $localStorage.cockpit.marketing = { aci : true };
      }
    };

    const sidenavAutomaticCheckinListener = $rootScope.$on('sidenavAutomaticCheckin:open', function (event, segment) {
      $scope.loadLocalStorageMarketingFlag();

      $scope.resetCheckinSidenav();
      $scope.segment = segment;

      $scope.status = 'loading';

      try {
        $scope.setProfileData();
        $scope.getACIMarkup();

        var logRequestParams = {
          interactionName: 'upsell-automatic-checkin-2-opened',
          filekey: $rootScope.activeFilekey,
          lastname: $rootScope.activeLastname,
          language: $rootScope.activeLocale
        };

        logsProvider.logInteraction(logRequestParams);

        angular.forEach($rootScope.booking.passengers, function (passenger) {
          if (passenger.passengerTypeCode !== 'INF') {
            $scope.passengersFrequentFlyerNumber.push({
              pnrPosition: passenger.pnrPosition,
              name: null,
              membership_number: null
            });
          }
        });

        $scope.passengersWithoutInfant = $scope.getPassengersWithoutInfant();
        $scope.getInitPassenger();
        $scope.status = 'success';
      } catch (e) {
        $scope.status = 'error';
      }
    });

    $scope.$on('$destroy', sidenavAutomaticCheckinListener);

    $scope.getACIMarkup = function() {
      markups.getMarkups(['automaticCheckin']).then(
        function successCallback(response) {
          if (response.meta && response.meta.success && response.data) {
            $scope.markupACI = response.data.automaticCheckin;
            $scope.setCheckinData();
          } else {
            throw 'Automatic checkin markups error.';
          }
        },
        function errorCallback() {
          throw 'Automatic checkin markups error.';
        }
      );
    };

    $scope.getInitPassenger = function() {
      angular.forEach($rootScope.booking.passengers, function(passenger) {
        if (passenger.passengerTypeCode !== 'INF') {
          $scope.checkinPassengerList.push({
            pnrPosition: passenger.pnrPosition,
            selected: false,
            passengerTypeCode: passenger.passengerTypeCode
          });
        }
      });
    };

    $scope.preFillForms = function() {
      $scope.first = true;

      if (profileHelper.isLoggedIn()) {
        var profileData = $scope.profile && $scope.profile.data;
      }

      $scope.resetDates();

      var passengerData = $filter('filter')($rootScope.booking.passengers, {'pnrPosition': $scope.selectedPassengerPnrPosition})[0];

      // pre-fill from booking if not present in basket
      $scope.checkinData[$scope.selectedPassengerPnrPosition]['gender'] = $scope.checkinData[$scope.selectedPassengerPnrPosition]['gender'] || passengerData.gender;
      $scope.checkinData[$scope.selectedPassengerPnrPosition]['documentNumber'] = $scope.checkinData[$scope.selectedPassengerPnrPosition]['documentNumber'] || passengerData.documentNumber;
      $scope.checkinData[$scope.selectedPassengerPnrPosition]['documentIssuingCountry'] = $scope.checkinData[$scope.selectedPassengerPnrPosition]['documentIssuingCountry'] || passengerData.documentIssuingCountry;
      $scope.checkinData[$scope.selectedPassengerPnrPosition]['mobilePhone'] = $scope.checkinData[$scope.selectedPassengerPnrPosition]['mobilePhone'] || (profileData && profileData.mobileNumber);
      $scope.checkinData[$scope.selectedPassengerPnrPosition]['documentType'] = $scope.checkinData[$scope.selectedPassengerPnrPosition]['documentType'] || null;

      $scope.validateDropdown($scope.selectedPassengerPnrPosition, 'travelDocumentsForm', 'documentNumber');
      $scope.validateDropdown($scope.selectedPassengerPnrPosition, 'travelDocumentsForm', 'documentIssuingCountry');
      $scope.validateDropdown($scope.selectedPassengerPnrPosition, 'advancePassengerInformationForm', 'mobilePhone');
    };

    $scope.setCheckinData = function() {
      if ($localStorage.cockpit.baskets[$rootScope.activeFilekey] && $localStorage.cockpit.baskets[$rootScope.activeFilekey].automaticCheckins) {
        angular.forEach($localStorage.cockpit.baskets[$rootScope.activeFilekey].automaticCheckins.passengers, function(passengerACI, pnrPosition) {
          angular.merge($localStorage.cockpit.baskets[$rootScope.activeFilekey].automaticCheckins.passengers[pnrPosition], $scope.markupACI);
        });

        $scope.checkinData = angular.copy($localStorage.cockpit.baskets[$rootScope.activeFilekey].automaticCheckins.passengers);
        $scope.resetDates();

        $scope.email.value = angular.copy($localStorage.cockpit.baskets[$rootScope.activeFilekey].automaticCheckins.email);
      }
    };

    $scope.resetDates = function() {
      var passengerList = ($localStorage.cockpit.baskets[$rootScope.activeFilekey] && $localStorage.cockpit.baskets[$rootScope.activeFilekey].automaticCheckins && $localStorage.cockpit.baskets[$rootScope.activeFilekey].automaticCheckins.passengers)
                          || $rootScope.booking.passengers;
      var passengerData = $filter('filter')($filter('toArray')(passengerList), {'pnrPosition': $scope.selectedPassengerPnrPosition})[0];

      if (passengerData) {
        $scope.dates[$scope.selectedPassengerPnrPosition] = $scope.dates[$scope.selectedPassengerPnrPosition] || {};

        if (passengerData.birthday) {
          var splittedBirthday = passengerData.birthday.split("-");
          $scope.dates[$scope.selectedPassengerPnrPosition]['birthdayDay'] = splittedBirthday[2];
          $scope.dates[$scope.selectedPassengerPnrPosition]['birthdayDayPrevious'] = splittedBirthday[2];
          $scope.dates[$scope.selectedPassengerPnrPosition]['birthdayMonth'] = splittedBirthday[1];
          $scope.dates[$scope.selectedPassengerPnrPosition]['birthdayMonthPrevious'] = splittedBirthday[1];
          $scope.dates[$scope.selectedPassengerPnrPosition]['birthdayYear'] = splittedBirthday[0];
          $scope.dates[$scope.selectedPassengerPnrPosition]['birthdayYearPrevious'] = splittedBirthday[0];
          $scope.dates[$scope.selectedPassengerPnrPosition]['birthdayChanged'] = false;
          $scope.validateDropdown($scope.selectedPassengerPnrPosition, 'advancePassengerInformationForm', 'birthdayYear');
          $scope.validateDropdown($scope.selectedPassengerPnrPosition, 'advancePassengerInformationForm', 'birthdayMonth');
          $scope.validateDropdown($scope.selectedPassengerPnrPosition, 'advancePassengerInformationForm', 'birthdayDay');
        }

        if (passengerData.documentIssuingDate) {
          var splittedDocumentIssuingDate = passengerData.documentIssuingDate.split("-");
          $scope.dates[$scope.selectedPassengerPnrPosition]['documentIssuingDay'] = splittedDocumentIssuingDate[2];
          $scope.dates[$scope.selectedPassengerPnrPosition]['documentIssuingMonth'] = splittedDocumentIssuingDate[1];
          $scope.dates[$scope.selectedPassengerPnrPosition]['documentIssuingYear'] = splittedDocumentIssuingDate[0];
          $scope.validateDropdown($scope.selectedPassengerPnrPosition, 'travelDocumentsForm', 'documentIssuingYear');
          $scope.validateDropdown($scope.selectedPassengerPnrPosition, 'travelDocumentsForm', 'documentIssuingMonth');
          $scope.validateDropdown($scope.selectedPassengerPnrPosition, 'travelDocumentsForm', 'documentIssuingDay');
        }

        if (passengerData.documentExpirationDate) {
          var splittedDocumentExpirationDate = passengerData.documentExpirationDate.split("-");
          $scope.dates[$scope.selectedPassengerPnrPosition]['documentExpirationDay'] = splittedDocumentExpirationDate[2];
          $scope.dates[$scope.selectedPassengerPnrPosition]['documentExpirationMonth'] = splittedDocumentExpirationDate[1];
          $scope.dates[$scope.selectedPassengerPnrPosition]['documentExpirationYear'] = splittedDocumentExpirationDate[0];
          $scope.validateDropdown($scope.selectedPassengerPnrPosition, 'travelDocumentsForm', 'documentExpirationYear');
          $scope.validateDropdown($scope.selectedPassengerPnrPosition, 'travelDocumentsForm', 'documentExpirationMonth');
          $scope.validateDropdown($scope.selectedPassengerPnrPosition, 'travelDocumentsForm', 'documentExpirationDay');
        }
      }
    };

    $scope.hasNationalitySelected = function() {
      var hasNationalitySelected = false;

      angular.forEach($scope.checkinData, function(passengerData) {
        if (passengerData.nationality) {
          hasNationalitySelected = true;
        }
      });

      return hasNationalitySelected;
    };

    $scope.validateForm = function(passengerForm, section) {
      var sectionForm = section + 'Form';

      if (  passengerForm &&
            section &&
            $scope.requirements &&
            $scope.checkinForm &&
            $scope.checkinForm[passengerForm][sectionForm]
      ) {
        angular.forEach($scope.checkinForm[passengerForm][sectionForm].$error, function(errorType) {
          angular.forEach(errorType, function(errorField) {
            errorField.$setTouched();
          });
        });
      }
    };

    $scope.addAutomaticCheckinToBasket = function() {
      $scope.checkinForm.$setSubmitted();
      $scope.checkinForm.email.$setDirty();
      $scope.status = 'automaticCheckinsRequirementsSuccess';

      angular.forEach($scope.checkinData, function(passenger, pnrPosition) {
        $scope.validateForm(pnrPosition, 'travelDocuments');
        $scope.validateForm(pnrPosition, 'advancePassengerInformation');
      });

      if (!$scope.hasNationalitySelected()) {
        $scope.status = 'automaticCheckinCreateNoNationality';
        return;
      }

      if (!$scope.checkinForm.$valid) {
        $scope.status = 'automaticCheckinCreateFormErrors';
        return;
      }

      var payload = {
        'filekey': $rootScope.activeFilekey,
        'lastname': $rootScope.activeLastname,
        'email': $scope.email.value,
        'preferences': {
          'seating': $scope.seatPreferences.seating,
          'locationInPlane': $scope.seatPreferences.locationInPlane,
        },
        'passengers': $scope.checkinData
      };

      angular.forEach($scope.checkinData, function(passenger, pnrPosition) {
        var bookingPassenger = $filter('filter')($rootScope.booking.passengers, {'pnrPosition': pnrPosition})[0];
        passenger.firstName = bookingPassenger.firstname;
        passenger.lastName = bookingPassenger.lastname;
        passenger.pnrPosition = bookingPassenger.pnrPosition;
        angular.merge(passenger, $scope.markupACI);

        if ($scope.dates[pnrPosition]) {
          if ($scope.dates[pnrPosition].birthdayDay) {
            passenger.birthday = $scope.dates[pnrPosition].birthdayYear + '-' + $scope.dates[pnrPosition].birthdayMonth + '-' + $scope.dates[pnrPosition].birthdayDay;
          }

          if ($scope.dates[pnrPosition].documentIssuingDay) {
            passenger.documentIssuingDate = $scope.dates[pnrPosition].documentIssuingYear + '-' + $scope.dates[pnrPosition].documentIssuingMonth + '-' + $scope.dates[pnrPosition].documentIssuingDay;
          }

          if ($scope.dates[pnrPosition].documentExpirationDay) {
            passenger.documentExpirationDate = $scope.dates[pnrPosition].documentExpirationYear + '-' + $scope.dates[pnrPosition].documentExpirationMonth + '-' + $scope.dates[pnrPosition].documentExpirationDay;
          }
        }

        angular.forEach(passenger.frequentFlyerPrograms, function(frequentFlyerProgram) {
          if ($scope.frequentFlyerPrograms.indexOf(frequentFlyerProgram.name) === -1 || frequentFlyerProgram.name === gettextCatalog.getString('None')) {
            delete passenger.frequentFlyerPrograms[0];
          }

          if ($filter('isEmpty')(passenger.frequentFlyerPrograms)) {
            delete passenger.frequentFlyerPrograms;
          }
        });
      });

      $localStorage.cockpit.baskets[$rootScope.activeFilekey] = $localStorage.cockpit.baskets[$rootScope.activeFilekey] || {};
      $localStorage.cockpit.baskets[$rootScope.activeFilekey].automaticCheckins = angular.copy(payload);
      $rootScope.$emit('refreshBasket');

      var logRequestParams = {
        interactionName: 'upsell-automatic-checkin-5-basket',
        filekey: $rootScope.activeFilekey,
        lastname: $rootScope.activeLastname,
        language: $rootScope.activeLocale
      };

      logsProvider.logInteraction(logRequestParams);
    };

    $scope.resetPassengerAci = function(pnrPosition, event) {
      if (event) {
        event.stopPropagation();
      }

      delete $scope.checkinData[pnrPosition];
      $scope.removeAutomaticCheckinFromBasket(pnrPosition);
    };

    $scope.removeAutomaticCheckinFromBasket = function(pnrPosition, event) {
      basketHelper.removeAutomaticCheckinFromBasket(pnrPosition, event);
    };

    $scope.setCountries = function() {
      return countries.getCountries();
    };

    $scope.getAutomaticCheckinRequirements = function(countryCode) {
      if (countryCode) {
        $scope.status = 'automaticCheckinsRequirementsLoading';

        var requestParams = {
          pnrIdentifier: $rootScope.pnrIdentifier,
          filekey: $rootScope.activeFilekey,
          lastname: $rootScope.activeLastname,
          nationality: countryCode,
          locale: $rootScope.activeLocale
        };

        automaticCheckin.getAutomaticCheckinRequirements(requestParams).then(
          function successCallback(response) {
            if (response.meta && response.meta.success && response.data.available === 'success') {
              $scope.status = 'automaticCheckinsRequirementsSuccess';
              $scope.requirements[$scope.selectedPassengerPnrPosition] = response.data;
              $scope.preFillForms();

              var logRequestParams = {
                interactionName: 'upsell-automatic-checkin-3-requirements',
                filekey: $rootScope.activeFilekey,
                lastname: $rootScope.activeLastname,
                language: $rootScope.activeLocale
              };

              logsProvider.logInteraction(logRequestParams);
            } else {
              $scope.status = 'error';
            }
          },
          function errorCallback() {
            $scope.status = 'error';
          }
        )
      }
    };

    $scope.isFrequentFlyerNumberRequired = function(frequentFlyerProgram) {
      return frequentFlyerProgram && frequentFlyerProgram !== gettextCatalog.getString('None');
    };

    $scope.isFrequentFlyerProgramRequired = function(frequentFlyerProgram) {
      return frequentFlyerProgram && frequentFlyerProgram.membershipNumber && (!frequentFlyerProgram.name || frequentFlyerProgram.name === gettextCatalog.getString('None'));
    };

    $scope.prepareYearsDropdown = function(isFuture) {
      var start = isFuture ? moment().year() : moment().year() - 120;
      var end = isFuture ? moment().year() + 10 : moment().year();

      return $scope.getRange(start, end);
    };

    $scope.getRange = function(start, end) {
      var range = [];

      for (var i = start; i <= end; i++) {
        var nb = i < 10 ? "0" + i : i;
        range.push(nb);
      }

      return range;
    };

    $scope.getNumberOfDaysInMonth = function(year, month) {
      return moment(year + '-' + month, 'YYYY-MM').daysInMonth();
    };

    $scope.daysInMonth = function(year, month) {
      return year === moment.utc().format('YYYY') && month === moment.utc().format('MM') ? moment.utc().format('D') : moment(year + '-' + month, 'YYYY-MM').daysInMonth();
    };

    $scope.monthsInYear = function(year) {
      if (year) {
        return year === moment.utc().format('YYYY') ? moment.utc().format('MM') : 12;
      }
    };

    $scope.displayMonth = function(year, month, isFuture) {
      if (year && month) {
        return isFuture && year === moment.utc().format('YYYY') ? parseInt(month) >= parseInt($scope.monthsInYear(year)) : parseInt(month) <= parseInt($scope.monthsInYear(year));
      }
    };

    $scope.displayDay = function(year, month, day, isFuture) {
      if (year && month) {
        if (isFuture && year === moment.utc().format('YYYY') && month === moment.utc().format('MM')) {
          return day >= $scope.daysInMonth(year, month);
        } else {
          return day <= $scope.daysInMonth(year, month);
        }
      }
    };

    $scope.getPassengersWithoutInfant = function() {
      var adultOrChildPassengers = [];

      if ($rootScope.booking && $rootScope.booking.segments[0]) {
        angular.forEach($rootScope.booking.segments[0].passengers, function(passenger) {
          if (passenger.passengerTypeCode !== 'INF') {
            adultOrChildPassengers.push(passenger);
          }
        });
      }

      return adultOrChildPassengers;
    };

    $scope.selectPassenger = function(pnrPosition) {
      if (pnrPosition) {
        $scope.selectedPassengerPnrPosition = pnrPosition;
        $scope.isSeatPreferenceOpen = false;
        $scope.isPassengerDetailsOpen = true;

        var passengerData = $filter('filter')($filter('toArray')($rootScope.booking.passengers), {'pnrPosition': $scope.selectedPassengerPnrPosition})[0];
        var checkinPassenger = $filter('filter')($scope.checkinPassengerList, {'pnrPosition': pnrPosition})[0];
        checkinPassenger['documentType'] = passengerData.documentType;
        checkinPassenger['nationality'] = passengerData.nationality;

        if (checkinPassenger['nationality']) {
          $scope.getAutomaticCheckinRequirements(checkinPassenger['nationality']);
        }

        $scope.openCheckinMobileSidenav();
      }

      angular.forEach($scope.checkinPassengerList, function(passengerCheckin, index) {
        $scope.checkinPassengerList[index].selected = passengerCheckin.pnrPosition === pnrPosition;
      });

      if ($scope.checkinData[$scope.selectedPassengerPnrPosition] && $scope.checkinData[$scope.selectedPassengerPnrPosition].nationality && !$scope.requirements[$scope.selectedPassengerPnrPosition]) {
        $scope.getAutomaticCheckinRequirements($scope.checkinData[$scope.selectedPassengerPnrPosition].nationality);
      }
    };

    $scope.selectSeatPreference = function() {
      if ($scope.selectedPassengerPnrPosition) {
        var passengerSelected = $filter('filter')($scope.checkinPassengerList, {'pnrPosition': $scope.selectedPassengerPnrPosition})[0];
        passengerSelected.selected = false;
        $scope.selectedPassengerPnrPosition = null;
        $scope.isPassengerDetailsOpen = false;
      }

      $scope.isSeatPreferenceOpen = true;

      $scope.openCheckinMobileSidenav();

      var logRequestParams = {
        interactionName: 'upsell-automatic-checkin-4-seats',
        filekey: $rootScope.activeFilekey,
        lastname: $rootScope.activeLastname,
        language: $rootScope.activeLocale
      };

      logsProvider.logInteraction(logRequestParams);
    };

    $scope.openCheckinMobileSidenav = function() {
      if ($rootScope.isExtraSmallScreen) {
        $mdSidenav('sidenavAutomaticCheckinMobile').open();
      }
    };

    $scope.getAirlineTail = function(operatingAirlineCode) {
      if (operatingAirlineCode) {
        return cockpitCdnUrl + '/airlines/tails/' + $filter('lowercase')(operatingAirlineCode) + '.png';
      }
    };

    $scope.setProfileData = function() {
      $scope.email.value = $rootScope.profile && $rootScope.profile.data && $rootScope.profile.data.email;
    };

    $scope.close = function(sideNav) {
      if (sideNav === 'mobile') {
        $mdSidenav('sidenavAutomaticCheckinMobile').close();

        if ($scope.isPassengerDetailsOpen) {
          var passengerSelected = $filter('filter')($scope.checkinPassengerList, {'pnrPosition': $scope.selectedPassengerPnrPosition})[0];
          passengerSelected.selected = false;
          $scope.selectedPassengerPnrPosition = null;
          $scope.isPassengerDetailsOpen = false;
        } else {
          $scope.isSeatPreferenceOpen = false;
        }
      } else if (sideNav === 'desktop') {
        $mdSidenav('sidenavAutomaticCheckin').close();
      }
    };

    $scope.validateDropdown = function(passengerForm, sectionForm, name) {
      if ($scope.checkinForm[passengerForm] && $scope.checkinForm[passengerForm][sectionForm] && $scope.checkinForm[passengerForm][sectionForm][name]) {
        $scope.checkinForm[passengerForm][sectionForm][name].$setTouched();
      }
    };

    $scope.openBasket = function() {
      $scope.close('mobile');
      $scope.close('desktop');
      basketHelper.toggleBasket(true);
    };

    $scope.clearDocumentTypeRelatedData = function(pnrPosition) {
      if ($scope.first) {
        $scope.first = false;
        return;
      }

      const travelDocumentFields = [
          'documentIssuingCountry',
          'documentNumber',
          'documentIssuingDay',
          'documentIssuingMonth',
          'documentIssuingYear',
          'documentExpirationDay',
          'documentExpirationMonth',
          'documentExpirationYear'
      ];

      angular.forEach(travelDocumentFields, function(field) {
        if ($scope.checkinForm && $scope.checkinForm[pnrPosition] && $scope.checkinForm[pnrPosition]['travelDocumentsForm'][field]) {
          $scope.checkinForm[pnrPosition]['travelDocumentsForm'][field].$setUntouched();
          $scope.checkinForm[pnrPosition]['travelDocumentsForm'][field].$setPristine();
        }
        if ($scope.checkinData && $scope.checkinData[pnrPosition] && $scope.checkinData[pnrPosition][field]) {
          $scope.checkinData[pnrPosition][field] = null;
        }
        if ($scope.dates && $scope.dates[pnrPosition] && $scope.dates[pnrPosition][field]) {
          $scope.dates[pnrPosition][field] = null;
        }
      });
    };

    $scope.checkBirthday = function(pnrPosition) {
        if(
            $scope.dates[pnrPosition].birthdayYearPrevious &&
            $scope.dates[pnrPosition].birthdayMonthPrevious &&
            $scope.dates[pnrPosition].birthdayDayPrevious
        ){
            const currentBirthday = $scope.dates[pnrPosition].birthdayYear + '-' + $scope.dates[pnrPosition].birthdayMonth + '-' + $scope.dates[pnrPosition].birthdayDay;
            const previousBirthday = $scope.dates[pnrPosition].birthdayYearPrevious + '-' + $scope.dates[pnrPosition].birthdayMonthPrevious + '-' + $scope.dates[pnrPosition].birthdayDayPrevious;

            $scope.dates[pnrPosition].birthdateChanged = currentBirthday !== previousBirthday;
        }
    };
  }
]);
